import { Button, Input, Space } from 'antd';
import { SendOutlined } from '@ant-design/icons';

const { TextArea } = Input;

export interface AgentInputProps {
  value: string;
  onChange: (v: string) => void;
  onSend: () => void;
  disabled?: boolean;
  placeholder?: string;
}

export function AgentInput({ value, onChange, onSend, disabled, placeholder }: AgentInputProps) {
  return (
    <Space.Compact style={{ width: '100%' }} direction="vertical">
      <TextArea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onPressEnter={(e) => {
          if (!e.shiftKey) {
            e.preventDefault();
            onSend();
          }
        }}
        placeholder={placeholder ?? 'Ask anything about your ERP data in plain language… (Shift+Enter for newline)'}
        autoSize={{ minRows: 2, maxRows: 6 }}
        disabled={disabled}
        style={{ fontSize: 14 }}
      />
      <Button
        type="primary"
        icon={<SendOutlined />}
        onClick={onSend}
        disabled={disabled || !value.trim()}
        block
      >
        Send
      </Button>
    </Space.Compact>
  );
}
